import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Window, WindowContent, WindowHeader } from 'react95';

import Ani from './image/ani.png';

import styled from 'styled-components';
import MinimizeIcon from '@mui/icons-material/Minimize';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
const Wrapper = styled.div`
  padding: 1rem;

  .window-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .window {
    width: 100%;
  }

  .content-inner {
    display: flex;
    gap: 1.5rem;
    align-items: flex-start;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .ani-image {
    max-width: 250px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: auto;
      border-radius: 8px;
    }

    @media (max-width: 768px) {
      max-width: 80%;
      margin: 0 auto;
    }
  }

  .ani-text {
    flex: 1;
  }

  .footerdes {
    margin-top: 1rem;
    font-size: 1rem;
    line-height: 1.6;
  }
`;

function Desktop() {
  const [open, setOpen] = useState(false);
  return (
    <Wrapper className='container'>
      <br />
      <div className='content-wrapper'>
        <div className='window-container glowy'>
          <Window resizable className=''>
            <WindowHeader className='window-title'>
              <span className='fonan'>2014 to Forever</span>
              <div>
                <Button>
                  <MinimizeIcon />
                </Button>
                <Button>
                  <CheckBoxOutlineBlankIcon />
                </Button>
                <Button>
                  <CloseIcon />
                </Button>
              </div>
            </WindowHeader>

            <WindowContent>
              <div className='content-inner'>
                <div className='ani-image'>
                  <img src={Ani} alt='Ani' />
                </div>
                <div className='ani-text '>
                  <p className='footerdes textvs' style={{ color: '#000' }}>
                    Animecoin ($ANI) is the first anime-themed cryptocurrency,
                    originally created in 2014 on the BitcoinTalk forums by an
                    anonymous user known as Ani-Chan. Animecoin ($ANI) is the
                    original anime-themed crypto, created in 2014 by Ani-Chan.
                    Now revived on Solana, it’s not a copy — it’s the same name,
                    same vision, and same culture, rebuilt for today’s anime and
                    Web3 community.
                  </p>
                </div>
              </div>
            </WindowContent>
          </Window>
        </div>
      </div>
    </Wrapper>
  );
}

export default Desktop;
